module.exports = __webpack_public_path__ + "img/iconfont.492ab95.svg";